import React from 'react';
import { dashboardMuted } from '../../theme/dashboardLayout';
import { healthScoreContextLines } from '../PopulationPulse/healthScoreContext';
import { isEmptyOrganisationHealthScore } from '../PopulationPulse/mapResponses';
import { formatShortDate } from '../PopulationPulse/utils/formatDates';
import { HealthScoreContextList } from '../PopulationPulse/ScorePeriodMark';
import HealthScoreOverallGauge from './HealthScoreOverallGuage';

interface Props {
  score?: number | null;
  updatedAt?: string | null;
  contributorCount?: number | null;
  enrolledMembers?: number | null;
  previousScore?: number | null;
  scoreName?: string;
  qualityCoefficient?: number | null;
}

function OrganisationHealthScoreBlock({
  score,
  updatedAt,
  contributorCount,
  enrolledMembers,
  previousScore,
  scoreName,
  qualityCoefficient,
}: Props): React.ReactElement {
  const empty = isEmptyOrganisationHealthScore(score);
  const contextLines = empty
    ? []
    : healthScoreContextLines({
      contributorCount,
      enrolledMembers,
      currentScore: score,
      previousScore,
    });
  if (!empty && qualityCoefficient != null) {
    const qualityDate = updatedAt ? formatShortDate(updatedAt.slice(0, 10)) : '';
    const qualityLine = {
      key: 'quality',
      text: qualityDate
        ? `Quality coefficient ${qualityCoefficient} as of ${qualityDate}`
        : `Quality coefficient ${qualityCoefficient}`,
    };
    const keepBuildingIndex = contextLines.findIndex(
      (line) => line.text === 'Keep building momentum to see more data',
    );
    if (keepBuildingIndex >= 0) {
      contextLines.splice(keepBuildingIndex, 0, qualityLine);
    } else {
      contextLines.push(qualityLine);
    }
  }
  const calculationDate = updatedAt ? new Date(`${updatedAt.slice(0, 10)}T00:00:00Z`) : new Date();

  return (
    <div className="mt-2 flex flex-col items-center gap-4">
      <HealthScoreOverallGauge
        value={score}
        benchmark="70"
        calculationDate={Number.isNaN(calculationDate.getTime()) ? new Date() : calculationDate}
        scoreName={scoreName}
      />
      {!empty ? (
        <div className="flex flex-col items-center text-center">
          {contextLines.length > 0 ? (
            <HealthScoreContextList lines={contextLines} className={`space-y-1 ${dashboardMuted}`} />
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default OrganisationHealthScoreBlock;
